import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface SelectMagnitudeI {
	value: string;
	disabled?: boolean;
	onChange: (event: SelectChangeEvent<string>) => void;
}

export default function SelectMagnitude({ onChange, value, disabled }: SelectMagnitudeI) {

	return (
		<Select
			value={value}
			fullWidth
			onChange={onChange}
			disabled={disabled}
		>
			<MenuItem value="">Selecione</MenuItem>
			<MenuItem value="Insignificante">Insignificante</MenuItem>
			<MenuItem value="Pequeno">Pequeno</MenuItem>
			<MenuItem value="Médio">Médio</MenuItem>
			<MenuItem value="Grande">Grande</MenuItem>
		</Select>
	);
}